import { DataBean } from "../DataBean";

export class CostingMeasurementConstants extends DataBean {


    public async getCostingMeasurementConstants(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getCostingMeasurementConstants_Number", [id]);
    }
    public async getIndirectCostMeasurementConstants(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getIndirectCostMeasurementConstants_Number", [id]);
    }

}